var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _MetaData_countZoomLevels, _MetaData_countImageSizes;
import { TILE_SIZE } from '../consts';
export class MetaData {
    constructor(initialLayers, originalSize) {
        Object.defineProperty(this, "layers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "zoomLevels", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "originalWidth", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "originalHeight", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "getFullImageProps", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (level) => {
                return {
                    width: this.layers[level].width,
                    height: this.layers[level].height,
                };
            }
        });
        Object.defineProperty(this, "getLayers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                return this.layers;
            }
        });
        _MetaData_countZoomLevels.set(this, () => {
            const maxZoomTilesX = this.layers.at(-1).countX;
            const multiplier = 100 / Math.log2(maxZoomTilesX);
            const calculateLogScalePercentage = (val) => Math.log2(val) * multiplier;
            const zoomLevels = this.layers.map((item) => {
                const sizeRaw = item?.scalePercentage || item.countX / maxZoomTilesX;
                const logScalePercentage = calculateLogScalePercentage(item.countX);
                return {
                    id: item.id,
                    sizeRaw: sizeRaw * 100,
                    sizePercentageAccurate: Math.round(sizeRaw * 100),
                    sizeLogRaw: logScalePercentage,
                    sizeLogAccurate: Math.round(logScalePercentage),
                };
            });
            console.log('META/// new zoom levels', zoomLevels);
            return zoomLevels;
        });
        _MetaData_countImageSizes.set(this, () => {
            this.layers.forEach((layer) => {
                const sizeByTilesCountX = layer.countX * TILE_SIZE[0];
                const sizeByTilesCountY = layer.countY * TILE_SIZE[1];
                const probableSizeX = this.originalWidth;
                const probableSizeY = this.originalHeight;
                const fullScale = 1;
                let scale = fullScale;
                const delimiter = 2;
                let lastTileWidth = 0;
                let lastTileHeight = 0;
                const countLastTileSizes = (probablySizeX, probablySizeY) => {
                    const diffX = sizeByTilesCountX - probablySizeX;
                    const diffY = sizeByTilesCountY - probablySizeY;
                    if (diffX < 0 || diffY < 0) {
                        scale = scale / delimiter;
                        countLastTileSizes(probablySizeX / delimiter, probablySizeY / delimiter);
                    }
                    else {
                        lastTileWidth = TILE_SIZE[0] - diffX;
                        lastTileHeight = TILE_SIZE[1] - diffY;
                    }
                };
                countLastTileSizes(probableSizeX, probableSizeY);
                lastTileWidth = Math.round(lastTileWidth);
                lastTileHeight = Math.round(lastTileHeight);
                layer.lastTileWidth = lastTileWidth;
                layer.lastTileHeight = lastTileHeight;
                layer.width = sizeByTilesCountX - TILE_SIZE[0] + lastTileWidth;
                layer.height = sizeByTilesCountY - TILE_SIZE[1] + lastTileHeight;
                layer.scalePercentage = scale;
            });
        });
        Object.defineProperty(this, "getZoomLevels", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                return this.zoomLevels;
            }
        });
        this.layers = initialLayers;
        this.originalWidth = originalSize.width;
        this.originalHeight = originalSize.height;
        console.log('clog in metadata', this.layers);
        __classPrivateFieldGet(this, _MetaData_countImageSizes, "f").call(this);
        this.zoomLevels = __classPrivateFieldGet(this, _MetaData_countZoomLevels, "f").call(this);
    }
}
_MetaData_countZoomLevels = new WeakMap(), _MetaData_countImageSizes = new WeakMap();
